import { HttpContext } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { BaseDataResponse, BaseEntitiesResponse, BaseResponse, GenericListEntity, Notification, NotificationListParams, PushMessageListParams } from "@base/entities/BaseEntities";
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { Observable, ReplaySubject, tap } from "rxjs";
import { SysGlobals } from '../framework/sysglobals';
import { APIGatewayService } from "../gateway/APIGateway.service";


@Injectable()
export class PushMessageEndpoint extends BaseEndpointCRUD<Notification> {
    
    private _notificationReadSubject = new ReplaySubject<boolean>(1);
    public NotificationRead$ = this._notificationReadSubject.asObservable();

    //Constructor
    constructor(api: APIGatewayService) {
        super("PushMessage", api);
    }
    
    public GetPushMessages(Params: PushMessageListParams, options: DataLoadOptions): Observable<BaseEntitiesResponse<Notification>> {
        return this.api.ExecutePostAction(this.ControllerName, 'GetPushMessages', Params, options?.GetLoadOptions());
    }
    public GetPushMessagesUnread(): Observable<BaseDataResponse<[number, Notification[]]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetPushMessagesUnread', undefined, undefined, undefined,
            { 'ignoreLoadingBar': 'true' }, new HttpContext().set(SysGlobals.IgnoreSessionRefreshRequestToken, true));
    }
    public ReadPushNotification(notificationID: number): Observable<BaseResponse> {
        return this.api.ExecutePostAction(this.ControllerName, 'ReadPushMessage', null, { notificationID: notificationID })
            .pipe(tap(() => this._notificationReadSubject.next(true)));
    }
}
